import i18next from 'i18next'
import React from 'react'
import { FormControls } from '../../utils/forms'

type GraduationYearLayoutProps = {
  readOnly: boolean
  value: number | undefined
  onChange: (newValue: string) => void
  onBlur?: () => void
  isValid: boolean
  suppressHotjar?: boolean
}

export const GraduationYearLayout = (props: GraduationYearLayoutProps) => (
  <FormControls.FormSelectInGroup
    controlId="graduationYear"
    label={i18next.t('studentSubscription:graduationYear')}
    required={true}
    readOnly={props.readOnly}
    value={props.value?.toString() || ''}
    onChange={props.onChange}
    onBlur={props.onBlur}
    validation={
      props.isValid
        ? undefined
        : {
            kind: 'failed',
            message: i18next.t('studentSubscription:graduationYearError'),
          }
    }
    suppressHotjar={props.suppressHotjar}
  >
    {[
      <option value="" disabled={true} key="placeholder">
        {i18next.t('auth:selectPlaceholder', {
          entity: i18next.t('subscription:year').toLowerCase(),
        })}
      </option>,
      <option value={-1} key={-1}>
        {i18next.t('subscription:Unknown')}
      </option>,
      ...[1, 2, 3, 4, 5, 6, 7].map((i) => {
        const year = new Date().getFullYear() + i
        return <option key={year}>{year}</option>
      }),
    ]}
  </FormControls.FormSelectInGroup>
)
